import { c as _c } from "react/compiler-runtime";
import type { FC } from 'react';
import { cn } from '../../../libs/utils';
import SafeImage from '../SafeImage';
interface StatIconProps {
  type: 'poe' | 'fanTokens' | 'crystals' | 'fanTokens_new' | 'coins';
  size?: 'sm' | 'md';
  className?: string;
}

/**
 * Компонент иконки статистики (растровые иконки из макета)
 *
 * @example
 * <StatIcon type="poe" size="md" />
 * <StatIcon type="crystals" size="sm" />
 *
 * @param props - Пропсы компонента
 * @returns JSX.Element
 */
export const StatIcon: FC<StatIconProps> = t0 => {
  const $ = _c(13);
  const {
    type,
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? "md" : t1;
  const sizePx = size === "sm" ? 16 : 24;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      poe: "/images/header/poe.png",
      fanTokens: "/images/header/fanTokens.png",
      crystals: "/images/header/crystals.png",
      fanTokens_new: "/images/fanTokens_new.png",
      coins: "/images/header/coin.png"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const iconSrc = t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      poe: "POE",
      fanTokens: "Fan Token",
      crystals: "Crystal",
      fanTokens_new: "Fan Tokens",
      coins: "Coins"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const altText = t3;
  let t4;
  if ($[2] !== className) {
    t4 = cn("flex items-center justify-center", className);
    $[2] = className;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = iconSrc[type];
  const t6 = altText[type];
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      display: "block"
    };
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] !== className || $[6] !== sizePx || $[7] !== t5 || $[8] !== t6) {
    t8 = <SafeImage className={className} src={t5} alt={t6} width={sizePx} height={sizePx} style={t7} priority={true} quality={60} draggable={false} />;
    $[5] = className;
    $[6] = sizePx;
    $[7] = t5;
    $[8] = t6;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t4 || $[11] !== t8) {
    t9 = <div className={t4}>{t8}</div>;
    $[10] = t4;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  return t9;
};
export type { StatIconProps };